import React from "react"
import { Modal } from "antd";

type Props = {
    visible: boolean;
    onCancel: () => void
}

export const CreditsInfoModal = ({ visible, onCancel }: Props) => (
    <Modal width="50%" visible={visible} onCancel={onCancel} footer={null}>
        <h3>Kako rade krediti?</h3>
        <p>
            Krediti su najbrži i najjednostavniji način plaćanja promocija oglasa na našoj stranici. 1 kredit vrijedi 1 €, no kod kupnje većih paketa ostvaruješ dodatne popuste – što veći paket kupiš, to je cijena kredita povoljnija (popusti do 45%).
        </p>
        <br />
        <p>
            <strong> Krediti nemaju rok trajanja </strong> – možeš ih koristiti kad god ti zatrebaju, bez vremenskog ograničenja.
        </p>
        <br />
        <p>
            Primjer:
        </p>
        <ul>
            <li>10 kredita = 10 € (bez popusta)</li>
            <li>30 kredita = 27 € (10% popusta)</li>
            <li>50 kredita = 42,5 € (15% popusta)</li>
            <li>200 kredita = 150 € (25% popusta)</li>
            <li>500 kredita = 325 € (35% popusta)</li>
            <li>1000 kredita = 550 € (45% popusta)</li>
        </ul>
        <hr />
        <h3>
            Kako se troše krediti?
        </h3>
        <p>
            Kreditima možeš platiti isticanje oglasa na određeno trajanje. Što dulje isticanje odabereš, to je cijena po danu povoljnija.
        </p>
        <br />
        <p>
            Evo primjera u osobnim automobilima i nekretninama:
        </p>
        <ul>
            <li><strong>1 dan isticanja</strong> = 1 kredit (bez popusta)</li>
            <li><strong>3 dana isticanja</strong> = 2,5 kredita (16,7% popusta po danu)</li>
            <li><strong>7 dana isticanja</strong> = 5 kredita (28,6% popusta po danu)</li>
            <li><strong>14 dana isticanja</strong> = 8 kredita (42,9% popusta po danu)</li>
            <li><strong>30 dana isticanja</strong> = 15 kredita (50% popusta po danu)</li>
        </ul>
        <hr />
        <h3>
            Primjer cijene promocije oglasa u osobnim automobilima i nekretninama
        </h3>
        <p>
            <strong>
                Ako platiš bez popusta na kredite:
            </strong>
        </p>
        <ul>
            <li>24 sata promocije = 1 €</li>
            <li>30 dana promocije = 15 € (već 50% jeftinije od plaćanja po danu)</li>
        </ul>
        <p>
            <strong>
                Ako kupiš veći paket s 45% popusta na kredite:
            </strong>
        </p>
        <ul>
            <li>24 sata promocije = 0,55 €</li>
            <li>30 dana promocije = 8,25 €</li>
        </ul>
        <hr />
        <h3>
            Koliko uštediš kombinacijom popusta?
        </h3>
        <p>
            Kombiniraš dvije vrste popusta:
        </p>
        <ul>
            <li>
                <strong>
                    Popust na kupnju većeg paketa kredita (do 45%)
                </strong>
            </li>
            <li>
                <strong>
                    Popust na cijenu po danu za dulje trajanje isticanja (do 50%)
                </strong>
            </li>
        </ul>
        <p>
            Tako, primjerice za <strong>30 dana isticanja oglasa</strong>:
        </p>
        <ul>
            <li>
                Bez ikakvih popusta platio bi <strong>30 €</strong>
            </li>
            <li>
                Samo s popustom na trajanje platio bi <strong>15 €</strong>
            </li>
            <li>
                A s oba popusta (trajanje + jeftiniji krediti) platiš <strong>8,25 €</strong>
            </li>
        </ul>
        <p>
            <strong>Ukupna ušteda je čak 72,5%</strong> u odnosu na osnovnu cijenu!
        </p>
        <p>
            Dakle, kupnjom većeg paketa kredita i odabirom duljeg isticanja možeš <strong>značajno smanjiti trošak promocije oglasa</strong>.
        </p>
    </Modal>
)


// WEBPACK FOOTER //
// ./src/containers/CreditsPage/CreditsInfoModal/CreditsInfoModal.tsx